module.exports = __webpack_public_path__ + "img/granstra.a7a7a7.84741d72.svg";